import { createFeatureSelector } from '@ngrx/store';
import { DeleteInvoiceReducer, DeleteInvoiceState } from './delete-invoice.reducer';
import { InvoiceInfoReducer, InvoiceInfoState } from './invoices-info.reducer';
import { InvoicesReducer, InvoicesState } from './invoices.reducer';

export const featureInvoicesName = 'Invoices';

export interface DragonflyState {
  invoices: InvoicesState;
  invoiceInfo: InvoiceInfoState;
  deleteInvoice: DeleteInvoiceState;
}

export const moduleInvoicesReducers = {
  invoices: InvoicesReducer,
  invoiceInfo: InvoiceInfoReducer,
  deleteInvoice: DeleteInvoiceReducer,
};

export const getDragonflyState = createFeatureSelector<DragonflyState>(featureInvoicesName);
